export const getters = { 
	getLocale: state => { 
		//return state.route.params.language 
		return state.locale
	},
	getApiUrl: ( state ) => { 
		if( process.env.NODE_ENV == 'development'){
			let devLocale = (state.locale == 'es') ? '/' : '/en/'
			return state.apiUrl.replace('/[LOCALE]/', devLocale)
		}else{
			let globalLocale = window.location.href.includes('.com/en/') || window.location.href.includes('biv/en/') ? '/en/' : '/'
			return state.apiUrl.replace('/[LOCALE]/', globalLocale)
		}
		
		/* console.log(process.env.NODE_ENV)
		console.log( state.apiUrl.replace('/[LOCALE]/', globalLocale))
		return state.apiUrl.replace('/[LOCALE]/', globalLocale) */
		/* if( state.locales.includes(state.route.params.language) ){
			return state.apiUrl.replace('[LOCALE]', state.route.params.language) 
		}else{
			return state.apiUrl.replace('[LOCALE]', 'es') 
		} */
	},
	getBaseUrl: ( state ) => state.baseUrl,
	getAppVersion: ( state ) => state.appVersion,
	getPdfUrl: ( state ) => state.pdfUrl,
	getImgUrl: ( state ) => state.imgUrl,
	getRouteName: ( state ) => state.route.name,
	getRouteParams: ( state ) => state.route.params,
	getLineId: ( state ) => ( state.route.params.lin ) ? state.route.params.lin.substring(0, state.route.params.lin.indexOf('-')) : 0,
	getCategoryId: ( state ) => ( state.route.params.ctg ) ? state.route.params.ctg.substring(0, state.route.params.ctg.indexOf('-')) : 0,
	getSubcategoryId: ( state ) => ( state.route.params.sct ) ? state.route.params.sct.substring(0, state.route.params.sct.indexOf('-')) : 0,
	getTypeId: ( state ) => ( state.route.params.typ ) ? state.route.params.typ.substring(0, state.route.params.typ.indexOf('-')) : 0,
	getLine: ( state ) => state.route.params.lin,
	getCategory: ( state ) => state.route.params.ctg,
	getSubcategory: ( state ) => state.route.params.sct,
	getType: ( state ) => state.route.params.typ,
	getLoggedIn: ( state ) => state.loggedIn,
	getShoppingCart: ( state ) => state.shoppingCart,
	getShoppingCartLoading: ( state ) => state.shoppingCartLoading,
	getGlobalMessage: ( state ) => state.globalMessage,
	getUsername: ( state ) => state.username,
	getUserEmail: ( state ) => state.userEmail,
	getUserHasServices: (state) => state.userSrv,
	getSessionEndTime: ( state ) => state.sessionEndTime,
	getSessionType:  ( state ) => state.sessionType,
	getPunchOutUrl: ( state ) => state.punchOutUrl,
	getServices: ( state ) => state.services,
	getSelectedService: ( state ) => state.selectedService,	
	getSelectedFavlist: ( state ) => state.selectedFavlist,
	getAdVisibility: ( state ) => state.adVisibility,
	getFavlistsLocalesEnabled: ( state ) => state.favlistsLocalesEnabled,
	getFavlistsVisibility: ( state ) => state.favlistsLocalesEnabled.includes(state.locale) ? true : false
};
